import React from 'react';
import TextButton from 'components/TextButton';
import { avatarKeyMap, getImage, getImageWithBackground } from './utils';
import './UserAvatar.scss';

const UserAvatar = props => {
  const { avatarData, withBackground, edit, classNames, onClick } = props;

  const getAvatarKey = () => {
    if (avatarData && avatarKeyMap) {
      const selectedAvatarKey = Object.entries(avatarKeyMap).find(
        ([key, value]) => value === avatarData
      )?.[0];
      return selectedAvatarKey || 'Avatar-0';
    }
    return 'Avatar-0';
  };

  const getAltText = () => {
    if (withBackground) {
      return getAvatarKey();
    } else {
      return avatarData && avatarData.split('/').pop().split('.')[0];
    }
  };

  const Comp = onClick ? TextButton : 'div';

  return (
    <Comp
      className={`user-avatar-profile ${classNames}`}
      onClick={onClick || undefined}
    >
      {edit && <div className="circle-background"></div>}
      <img
        src={
          withBackground
            ? getImageWithBackground(getAvatarKey())
            : getImage(getAvatarKey())
        }
        alt={getAltText()}
        className={`user-avatar-profile-image ${classNames}`}
      />
    </Comp>
  );
};

export default UserAvatar;
